/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetGetProductVariantImagesUrlQueryResponse, GetGetProductVariantImagesUrlPathParams, GetGetProductVariantImagesUrlQueryParams, GetGetProductVariantImagesUrl400, GetGetProductVariantImagesUrl404 } from "../../models/GetGetProductVariantImagesUrl";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetGetProductVariantImagesUrlUrl({ code }: { code: GetGetProductVariantImagesUrlPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/variant-images-url` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/variant-images-url}
 */
export async function getGetProductVariantImagesUrl({ code, params }: { code: GetGetProductVariantImagesUrlPathParams["code"]; params: GetGetProductVariantImagesUrlQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetGetProductVariantImagesUrlQueryResponse, ResponseErrorConfig<GetGetProductVariantImagesUrl400 | GetGetProductVariantImagesUrl404>, unknown>({ method : "GET", url : getGetGetProductVariantImagesUrlUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}